import { css, etiColors, resetButtonStyle } from '@eti/styles';
import { Icon } from '@eti/components';
import { useTranslation } from '@eti/providers';
import PropTypes from 'prop-types';

const resetButtonStyles = css`
  cursor: pointer;
  margin-left: 10px;
  ${resetButtonStyle};

  html[dir='rtl'] & {
    margin-left: 0;
    margin-right: 10px;
  }
`;

const resetButtonLabelStyles = css`
  color: ${etiColors.info.solid};
  font-size: 0.875rem;
  margin-left: 4px;

  html[dir='rtl'] & {
    margin-left: 0;
    margin-right: 4px;
  }
`;

const ResetButton = ({ dataTestId, onClick }) => {
  const { t } = useTranslation();

  return (
    <button className={resetButtonStyles} data-testid={dataTestId} onClick={onClick} type="button">
      <Icon color={etiColors.info.solid} id="close" size="0.7rem" />
      <span className={resetButtonLabelStyles}>{t('Result.SearchFilters.Reset.Button')}</span>
    </button>
  );
};

ResetButton.propTypes = {
  dataTestId: PropTypes.string,
  onClick: PropTypes.func,
};

export default ResetButton;
